import { SweetAlertService } from './../../../../core/services/utils/sweet-alert.service';
import { LocalService } from './../../../../core/services/storage/local.service';
import { Component, OnInit } from '@angular/core';

import { ModalService } from 'src/app/core/services/utils/modal.service';
import { EmitService } from './../../../../core/services/utils/emit.service';

@Component({
  selector: 'app-modal-cerrar-sesion',
  templateUrl: './modal-cerrar-sesion.component.html',
  styleUrls: ['./modal-cerrar-sesion.component.css']
})
export class ModalCerrarSesionComponent implements OnInit {
  tipo: any;
  escritorio: any;

  constructor(
    private modalService: ModalService,
    private emit: EmitService,
    private localSecureService: LocalService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
    this.escritorio = this.localSecureService.getValue('escritorio');
  }

  cerrarSesion(){
    if(!this.localSecureService.getValue('consultora')) {
      this.sweetAlertService.swalInternet();
      return;
    }
    
    this.closeModal();
    this.sweetAlertService.swalLoading();
    this.emit.enviarData('cerrar');
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

  cerrar(){
    this.closeModal();
    if (this.tipo == 'derivar') {
      this.emit.enviarData('continuar');
    }
  }

}
